export { default } from './legalRichText';
